/* eslint-disable jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */

import React from 'react'
import { Modal, Button } from 'react-bootstrap'
import CrossTopIcon from '../images/cross_top.svg'
import ArrowGreenIcon from '../images/arrow-green.svg'

const style = {
  btn: {
    background: '#fd5021',
    border: 'none'
  }
}
const ErrorModal = ({ show, onHide, errorMsg }) => {
  return (
    <Modal show={show} onClick={onHide} onHide={onHide} size='md' centered>
      <Modal.Header
        style={{
          background: '#f3f3f3',
          color: '#fff',
          minHeight: '40px'
        }}
      >
        <span
          onClick={onHide}
          style={{ position: 'absolute', right: '10px', top: '4px' }}
        >
          <img src={CrossTopIcon} height='20px' alt='' />
        </span>
      </Modal.Header>
      <Modal.Body
        style={{ padding: '0 10px', color: '#d31d2c', textAlign: 'center' }}
      >
        <div className='m_modal'>
          <ul>
            {Object.values(errorMsg).map(
              err =>
                err &&
                err.split('**').map(errItem => (
                  <li key={errItem}>
                    <img src={ArrowGreenIcon} alt='' />
                    {errItem}
                  </li>
                ))
            )}
          </ul>
        </div>
      </Modal.Body>
      <Modal.Footer
        style={{
          float: 'left',
          width: '100%',
          padding: '10px 15px'
        }}
      >
        <Button style={style.btn} onClick={onHide}>
          Okay
        </Button>
      </Modal.Footer>
    </Modal>
  )
}
export default ErrorModal
